/**
 * 统一获取环境信息
 * @author tylerzzheng
 */

// export const isProd: boolean = true
export const isProd: boolean = ['tcc.tencent.com', 'bak.tcc.tencent.com'].includes(window.location.hostname)
